import { atom } from '@reatom/framework'
import i18next from 'i18next'

import { shortcutAppRouter } from '../app-shortcuts'

import type { ShortcutId } from '../shortcut-id'
import type { ShortcutRouteHandler } from '../shortcut-router'

export const reatomCheatSheetSearchModel = () => {
  const handlers = Object.entries(shortcutAppRouter) as Array<
    [ShortcutId, ShortcutRouteHandler]
  >
  const searchQueryAtom = atom('', 'searchQueryAtom')

  const searchResultsAtom = atom((ctx) => {
    const searchQuery = ctx.spy(searchQueryAtom).trim().toLowerCase()

    if (!searchQuery) {
      return handlers
    }

    return handlers.filter(([_, handler]) => {
      const description = i18next.t(handler.description)
      if (typeof description === 'string') {
        return description.toLowerCase().includes(searchQuery)
      }
      return false
    })
  }, 'searchResultsAtom')

  return {
    searchQueryAtom,
    searchResultsAtom,
  }
}
